export default "__VITE_ASSET__BVFaE14N__"